import React, { useState, useEffect } from 'react';
import { Button, Form, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { updateCustomerShipping } from '../utils/bedrockAPI';
import './AddressDisplay.css';

export default function AddressDisplay({ 
  address, 
  setShippingAddress,
  isEditingAddress,
  setIsEditingAddress,
  builderId,
  className = ''
}) {
//   const [isEditingAddress, setIsEditingAddress] = useState(false);
  const [editedAddress, setEditedAddress] = useState(null);

  useEffect(() => {
    if (address) {
      setEditedAddress({
        companyName: address.company || '',
        shippingName: address.name || '',
        shippingAddress: {
          line1: address.street || '',
          line2: '',
          city: address.city || '',
          state: address.state || '',
          postal_code: address.zip || '',
          country: 'US'
        },
        shippingPhone: address.phone || ''
      });
    }
  }, [address]);

  const handleAddressUpdate = async () => {
    try {
      await updateCustomerShipping(builderId, editedAddress);
      setShippingAddress({
        company: editedAddress.companyName,
        name: editedAddress.shippingName,
        phone: editedAddress.shippingPhone,
        street: editedAddress.shippingAddress.line1,
        city: editedAddress.shippingAddress.city,
        state: editedAddress.shippingAddress.state,
        zip: editedAddress.shippingAddress.postal_code
      });
      setIsEditingAddress(false);
    } catch (error) {
      console.error('Error updating shipping address:', error);
    }
  };

  if (!address) {
    return (
      <p className="address-not-found">
        No address found. Please update your billing information in your account settings.
      </p>
    );
  }

  return (
    <div className={`address-display ${className}`}>
      {!isEditingAddress ? (
        <div className="address">
          <div className="address-header">
            <Button 
              bsStyle="default"
              onClick={() => setIsEditingAddress(true)}
            >
              <i className="fas fa-pencil-alt"></i>
            </Button>
          </div>
          {address.company && <div className="company">{address.company}</div>}
          <div className="name">{address.name}</div>
          {address.phone && <div className="phone">{address.phone}</div>}
          <div className="street">{address.street}</div>
          <div className="city-state-zip">{address.city}, {address.state} {address.zip}</div>
        </div>
      ) : (
        <div className="address-edit-form">
          <Form>
            <FormGroup className="mb-3">
              <ControlLabel>Company Name (Optional)</ControlLabel>
              <FormControl
                type="text"
                value={editedAddress.companyName}
                onChange={(e) => setEditedAddress({...editedAddress, companyName: e.target.value})}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <ControlLabel>Full Name</ControlLabel>
              <FormControl
                type="text"
                value={editedAddress.shippingName}
                onChange={(e) => setEditedAddress({...editedAddress, shippingName: e.target.value})}
                required
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <ControlLabel>Phone Number</ControlLabel>
              <FormControl
                type="tel"
                value={editedAddress.shippingPhone}
                onChange={(e) => setEditedAddress({...editedAddress, shippingPhone: e.target.value})}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <ControlLabel>Street Address</ControlLabel>
              <FormControl
                type="text"
                value={editedAddress.shippingAddress.line1}
                onChange={(e) => setEditedAddress({
                  ...editedAddress,
                  shippingAddress: {...editedAddress.shippingAddress, line1: e.target.value}
                })}
                required
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <ControlLabel>City</ControlLabel>
              <FormControl
                type="text"
                value={editedAddress.shippingAddress.city}
                onChange={(e) => setEditedAddress({
                  ...editedAddress,
                  shippingAddress: {...editedAddress.shippingAddress, city: e.target.value}
                })}
                required
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <ControlLabel>State</ControlLabel>
              <FormControl
                type="text"
                value={editedAddress.shippingAddress.state}
                onChange={(e) => setEditedAddress({
                  ...editedAddress,
                  shippingAddress: {...editedAddress.shippingAddress, state: e.target.value}
                })}
                required
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <ControlLabel>ZIP Code</ControlLabel>
              <FormControl
                type="text"
                value={editedAddress.shippingAddress.postal_code}
                onChange={(e) => setEditedAddress({
                  ...editedAddress,
                  shippingAddress: {...editedAddress.shippingAddress, postal_code: e.target.value}
                })}
                required
              />
            </FormGroup>
          </Form>
          <div className="address-edit-actions">
            <Button onClick={handleAddressUpdate} variant="primary">Save Address</Button>
            <Button onClick={() => setIsEditingAddress(false)} variant="outline-secondary">Cancel</Button>
          </div>
        </div>
      )}
    </div>
  );
} 